<template>
    <transition name="fade">
        <div class="menu-category-all-wrap" @click="close">
            <div class="menu-category-all" @click.stop>
                <div class="menu-category-all-header">
                    <div class="menu-category-all-title">
                        {{ $t("pages.menu.blocks.categories.title") }}
                    </div>
                    <div class="menu-category-all-close" @click="close">
                        <IconBase width="26" height="26" view-box="0 0 22 22">
                            <IconPlus />
                        </IconBase>
                    </div>
                </div>
                <ul class="menu-category-all-ul">
                    <li class="menu-category-all-button" :class="{ 'selected': category.id == selectedCategory }"
                        v-for="category in categories" :key="category.id" @click="scrollMenu(category.id)">
                        {{ category.name }}
                        <IconBase v-show="category.id == selectedCategory" width="20" height="20" view-box="0 0 22 22">
                            <IconCheckmark />
                        </IconBase>
                    </li>
                </ul>
            </div>
        </div>
    </transition>
</template>

<script>
import IconBase from '@/components/IconBase.vue';
import IconCheckmark from '@/components/icons/IconCheckmark.vue';
import IconPlus from '@/components/icons/IconPlus.vue';

export default {
    name: "MenuInfScroll",
    components: {
        IconBase,
        IconCheckmark,
        IconPlus,
    },
    props: {
        isShown: { type: Boolean, required: true },
        categories: { type: Array, required: true },
        selectedCategory: { type: [String, Number], required: true },
    },
    data() {
        return {
            scrollPreventEl: null,
        };
    },
    mounted() {
        this.scrollPreventEl = document.getElementsByClassName("app_layout-content")[0];
    },
    watch: {
        isShown(newVal) {
            if (!this.scrollPreventEl) {
                return;
            }

            if (newVal) {
                this.scrollPreventEl.style.overflow = "hidden";
            } else {
                this.scrollPreventEl.style.overflow = "";
            }
        }
    },
    methods: {
        scrollMenu(id) {
            this.$emit("scrollMenu", id);
            this.close();
        },
        close() {
            this.$emit("close");
        }
    }
}
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

ul {
    list-style-type: none;
    padding: 0;
    margin: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.2s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.menu-category-all-wrap {
    position: absolute;
    top: 0;

    width: 100%;
    height: 100vh;

    z-index: 1000;
    user-select: none;
    backdrop-filter: blur(10px);
}

.menu-category-all {
    overflow: auto;
    max-height: calc(100vh - 100px);

    padding: 10px;

    border-bottom: 1px solid #EDEDED;
    box-shadow: 0px 1px 10px 0px #0000001A;

    background-color: white;
}

.menu-category-all-header {
    position: relative;

    display: flex;
    justify-content: center;
    padding: 10px;

    .menu-category-all-title {
        font-weight: 590;
        font-size: 16px;
        line-height: 100%;

        color: black;
    }

    .menu-category-all-close {
        position: absolute;
        right: 0;
        top: 50%;

        transform: translate(0, -50%) rotate(45deg);
    }
}


.menu-category-all-ul {
    display: grid;
    gap: 8px;

    width: 100%;
}

.menu-category-all-button {
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: 10px 16px;

    font-weight: 510;
    font-size: 14px;
    text-transform: capitalize;

    border: 1px solid #EDEDED;
    border-radius: 8px;

    color: black;
    background-color: $color_white_titan;
}

.selected {
    color: white;
    background-color: $color_blue_cornflower;
}
</style>